import React, { useContext } from "react"
import BannerContext from "../lib/context"

import Helmet from "react-helmet"

import Header from "../components/Header"
import { TextSection } from '../components/Section'
import BannerSection from "../components/BannerSection"

import ChildrenImage from '../assets/images/church/kids-ministry.jpg'
import YouthMinistry from '../assets/images/stock-photos/youth-ministry.jpg'


import YoungAdultImage from '../assets/images/groups/Youth-Groups.jpg'

import Fireplace from '../assets/images/church/mens-group.jpg'
import Emerge from '../assets/images/church/womens-group.jpg'

// import LifeImage from '../assets/images/home/life-groups2.jpg'
import LifeImage from '../assets/images/groups/Homegroups.jpg'
import DinnerParty from "../assets/images/church/dinner-party.jpg"
import InternationalDay from "../assets/images/church/international-day.jpg"
import BBQ from "../assets/images/church/bbq.jpg"
import YouthGroup from "../assets/images/church/youth-group.jpg"
import YouthActivity from "../assets/images/church/youth-activities.jpg"
import Gathering from "../assets/images/church/church-gathering.jpg"


const Homepage = () => {

    // const [ headerData, setHeaderData ] = useState( [ ] )
    const siteTitle = "Blackheath and Charlton Baptist Church - Church Life"
    // const pageData = useLocalData( getStaticPageData, 'church-life-banners', 'church-life-banners' )
    const pageData = useContext( BannerContext )[ 'church-life-banners' ]
    const { header, banners } = pageData || { header: null, banners: null }
    const headerImages = header ? header.images : []
    const headerTitle = header ? header.title : 'Church Life'
    // const headerImages = useData( getEventsHeader )
    // const headerTitle = "Church Life"
    const headerIcon = <span className="icon major"><i className="fas fa-heartbeat"></i></span>

    return (

        <div id='church-life-page'>
            <Header images={[ InternationalDay, BBQ, DinnerParty ]} headerTitle={headerTitle} tint={0.3} />
            <Helmet title={siteTitle} />

            <TextSection 
                id="life-groups" 
                title="Life Groups"
                description="Our Life Groups meet at various times throughout the week, providing a smaller, more intimate environment for individuals to share, disciple and grow together in the Word, prayer and fellowship.
                Members support and care for one another through life's celebrations, surprises and challenges. 
                We encourage everyone in our church family to be join a Life Group to build deeper relationships and walk alongside each other on our faith journey."
                buttons={[ { url: "/lifegroups", text: "Join Group",  style: 'transparent-button' } ]}
                background={[ Gathering ]}
                tint={0.5}
                blur={0.15}
                opacity={0.8}
            />

            <TextSection 
                id="prayer-meetings" 
                title="Prayer Meetings"
                style="blue"
                description={`
                    We are a church grounded in prayer. A house where prayer never stops and every heart can encounter the living God.
                    
                    <b><i><small>"My house will be called a house of prayer for all nations." Isaiah 56:7 (NIV)</small></i></b>

                    We are committed to being a sanctuary of constant prayer, a place of deep healing, and a people through whom God's love reaches the nations.

                    <b><i><small>"After this I looked, and there before me was a great multitude that no one could count, from every nation, tribe, people and language, standing before the throne and before the Lamb." Revelation 7:9 (NIV)</small></i></b>

Prayer at BCB Church is not a programme; it is our posture. It's how we live, how we love, and how we reach out with the love of Jesus Christ.
                    

                    <b>Join us on:</b>

                    Wednesdays 6:00am –7:00am
                    Fridays (prayer and fasting) 6:00am – 7:00am & 7:00pm – 8:30pm
                `}
                // buttons={[ { url: "/prayer-meetings", text: "Read More" } ]}
                // background={[ PrayerMeetingImage ]}   
                // tint={0.35}
                // opacity={0.2}
                buttons={[ { url: "/media/audio", text: "Audio Recordings",  style: 'special' } ]}
                // extraCSS={{backgroundColor: 'rgba(0, 55, 100, 0.1)'}}
            />


            <TextSection 
                id="childrens-church" 
                title="B.L.A.S.T - (Being Light and Salt)"
                description={`Our Children’s Church ministry provides children the opportunity to learn about Christ and scripture, through practical and interactive activities and conversations. 
                    We believe that creative learning enhances their ability to learn about God and engage with His Word.

Throughout the year we offer a variety of activities that allow children to connect with the wider church family through specific areas of interest  
to them. Our children’s ministry leaders have all undergone safeguarding training and are committed to prioritising the children’s safety and welfare. `
                }
                style="style2"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ ChildrenImage ]}
                alt
                tint={0.7}
                opacity={0.71}
                blur={0.15}
            />

            <TextSection 
                id="youth-ministry" 
                title="IGNITE - Youth Ministry"
                description={`<b><i><small>"Never be lacking in zeal, but keep your spiritual fervor, serving the Lord."</small></i></b>
<b><i><small>Romans 12:11 (NIV)</small></i></b>
<br/>
<b>The Mission</b>

IGNITE exists to fuel a relentless pursuit of Christ through intentional discipleship, biblical excellence, and servant-leadership. With the expectation of seeing a generation set ablaze by the presence of God, transforming into a living sanctuary of wisdom, diligence, and humility that illuminates the path for generations to come.


<b>We are committed to:</b>
<ul>
    <li>Kindling Devotion: Cultivating an environment where young people fall deeply in love with Jesus.</li>
    <li>Refining Character: Building lives of integrity, hard work, and humility through the power of the Holy Spirit.</li>
    <li>Empowering Leaders: Equipping the next generation to lead with wisdom and grace in every sphere of influence.</li>
</ul>
`}
                style="blue"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ YouthGroup ]}
                alt
                tint={0.6}
                opacity={0.6}
                blur={0.12}
            />

            <TextSection 
                id="young-adults"
                title="Young Adults Ministry"
                description={ `Our Young Adults’ Ministry serves those aged 18 to 35. 
                    The aim of this ministry is to disciple, nurture and equip our young adults to become fruitful Christians whose lives bear witness to the testimony of Jesus Christ. 
                    We encourage and nurture them to live lives that demonstrate the fruits of the Holy Spirit.
 
By grounding them in scripture, our young adults are pastored and equipped to live as intelligent, diligent and successful members and leaders of society.`}
                style="style1 large blue"
                // background={[ YoungAdultImage ]}
                tint={0.7}
                blur={0.3}
            />


            <TextSection 
                id="vertical-youth-club" 
                title="Vertical Youth Club"
                description={`Ever just wanted a place to hang out, be yourself, and know you're welcome? That's Vertical Youth Club. A safe, friendly space for young people to relax, make new friends, and have a good time together. Oh, and there's a free tuck shop too!

We're here with a listening ear, a helping hand, and real support for young people and their families whenever it's needed. From supervised digital games to loads of other fun activities, there's always something happening.

Come join in on fun activities, supervised digital games, and so much more. And if you're ever hungry, we've always got snacks and food to share. No questions asked.

We know things can feel heavy sometimes, especially for young people right now. That's why we're here to offer space, support, and mentorship whenever it's needed.

You belong here. Come and see for yourself!`}
                style="style2"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ YouthActivity ]}
                alt
                tint={0.7}
                opacity={0.7}
            />


            <TextSection 
                id="emerge"
                title="Emerge (Equipped to Thrive)"
                description={ `
                    <b><i><small>Rooted in scripture · Living a Life of Purpose · Ready for His return</small></i></b>
                    

                    <b>Vision</b>
                    To see women of faith emerge as God's workmanship, equipped to thrive in the gifts He has appointed, clothed in strength and dignity, and standing firm as households are made ready for the return of Christ.

                    <b>Mission</b>
                    The ministry exists to encourage women of faith to walk in fervency of spirit, never growing slack in diligence, but rising daily to nourish and shepherd their households. We commit to affirming and building one another up, adorning ourselves with the strength and honour that comes from God, and living in joyful readiness and confidence that our homes are prepared for the coming of our Lord.

`}
                style="style1"
                background={[ Emerge ]}
                tint={0.1}
                blur={0.15}
                blackText={true}
                opacity={0.25}
                alt
            />

            <TextSection 
                id="fireplace-ministry"
                title="Fireplace Ministry"
                description={ `The Fireplace Ministry is a dedicated men’s group that meets regularly for prayer, fellowship, and engaging activities such as golf.
                    In addition to spiritual growth and camaraderie, the ministry actively serves the church by helping maintain the grounds and ensuring the space remains welcoming for all.`}
                style="style1"
                background={[ Fireplace ]}
                tint={0.7}
                opacity={0.8}
                blur={0.02}
            />

        

            <BannerSection banners={banners} />


        </div>
    )
}

export default Homepage